
















import * as Vue from '@vue/composition-api'
import acceItems from '@/ts/model/acceItems'
import StageItemDescription from '@/ts/model/StageItemDescription'
import { Pos, Size } from '@/ts/if/graphics'

const isInRange = (n: number, min: number, max: number) => {
  return min <= n && n <= max
}

export default Vue.createComponent({
  name: 'StageItem',
  props: {
    id: {
      type: Number,
      required: true
    },
    acceName: {
      type: String,
      default: ''
    },
    initialPos: {
      type: Object,
      default: () => ({ x: 100, y: 100 })
    },
    initialScale: {
      type: Number
    },
    initialAngle: {
      type: Number
    },
    area: {
      type: Object,
      default: () => ({ x: 0, y: 0, w: 10000, h: 10000 })
    }
  },
  setup (props, ctx) {
    const drr = Vue.ref()
    const acceItem = Vue.computed(() => acceItems[props.acceName])

    const initialRect = {
      x: props.initialPos.x as number || 100,
      y: props.initialPos.y as number || 100,
      w: acceItem.value.imgSize.w * (props.initialScale || acceItem.value.defaultScale),
      h: acceItem.value.imgSize.h * (props.initialScale || acceItem.value.defaultScale)
    }
    const state = Vue.reactive({
      w: initialRect.w,
      h: initialRect.h,
      x: initialRect.x,
      y: initialRect.y,
      angle: props.initialAngle || 0
    })

    const posInfo = Vue.computed(() => `pos = ${Math.round(state.x)}, ${Math.round(state.y)}`)
    const sizeInfo = Vue.computed(() => `size = ${Math.round(state.w)}, ${Math.round(state.h)} (${Math.round(currentScale.value * 100)}%)`)
    const angleInfo = Vue.computed(() => `angle = ${Math.round(state.angle)}deg`)
    const currentScale = Vue.computed(() => state.w / acceItem.value.imgSize.w)
    const description = Vue.computed(() => {
      return new StageItemDescription(
        props.id,
        acceItem.value.type,
        acceItem.value.name,
        state.x,
        state.y,
        state.angle,
        currentScale.value,
        0
      )
    })

    const change = (newRect: any) => {
      const limW = { min: acceItem.value.imgSize.w * acceItem.value.scaleLimit.min, max: acceItem.value.imgSize.w * acceItem.value.scaleLimit.max }
      const limH = { min: acceItem.value.imgSize.h * acceItem.value.scaleLimit.min, max: acceItem.value.imgSize.h * acceItem.value.scaleLimit.max }
      const limX = { min: props.area.x, max: props.area.x + props.area.w }
      const limY = { min: props.area.y, max: props.area.y + props.area.h }
      const isInLimit = isInRange(newRect.x, limX.min, limX.max) && isInRange(newRect.y, limY.min, limY.max) && isInRange(newRect.w, limW.min, limW.max) && isInRange(newRect.h, limH.min, limH.max)
      if (isInLimit) {
        state.w = newRect.w
        state.h = newRect.h
        state.x = newRect.x
        state.y = newRect.y
        state.angle = newRect.angle

        const newPos: Pos = { x: state.x, y: state.y }
        const newScale = state.w / acceItem.value.imgSize.w
        const newAngle = state.angle
        ctx.emit('onChange', { pos: newPos, scale: newScale, angle: newAngle })
      }
      applyRect()
    }

    const onSelect = () => { ctx.emit('onSelect') }
    const onDeselect = () => { ctx.emit('onDeselect') }
    const deselect = () => {
      (drr.value as any).deselect()
    }
    const select = () => {
      (drr.value as any).active = true
    }

    const applyRect = () => {
      const drrComp = (drr.value as any)
      drrComp.cx = state.x
      drrComp.cy = state.y
      drrComp.width = state.w
      drrComp.height = state.h
    }

    return {
      drr,
      acceItem,
      state,
      change,
      posInfo,
      sizeInfo,
      angleInfo,
      currentScale,
      onSelect,
      onDeselect,
      deselect,
      select,
      description
    }
  }
})
